import { Component, Input, OnInit } from '@angular/core';
import { StrategyMappingKPI } from '../interfaces/StrategyMapping';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';

@Component({
  selector: 'app-strategy-mapping-list',
  templateUrl: './strategy-mapping-list.component.html',
  styleUrls: ['./strategy-mapping-list.component.scss']
})
export class StrategyMappingListComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;
  @Input() list: StrategyMappingKPI[] = [];
  @Input() language: string = '';
  @Input() hasTitle: boolean = false;
  constructor() { }

  ngOnInit(): void {}

}
